import {
    PluginMedia,
    PluginWorkSite,
} from 'rwl-shared/dist/models/plugin/Plugin';

/**
 * Returns the media in the order for the Collage.
 *
 * @param job The job you want media for
 * @returns Array of PluginMedia
 */
export const pluginMediaFromJob = (job: PluginWorkSite): PluginMedia[] => {
    return job.content.reduce((imgs, content) => {
        if (content.media) {
            imgs.push(...content.media);
        }
        return imgs;
    }, [] as PluginMedia[]);
};
